import { MouseEvent } from "react";
import { useImmer } from "use-immer";

export interface ColorPickerState {
  open: boolean;
  anchorEl: HTMLElement | null;
  activeField: string | null;
}
export const useColorPicker = () => {
  const [colorPickerState, setColorPickerState] = useImmer<ColorPickerState>({
    open: false,
    anchorEl: null,
    activeField: null,
  });

  const openColorPicker = (field: string, event: MouseEvent<HTMLElement>) => {
    setColorPickerState({
      open: true,
      anchorEl: event.currentTarget,
      activeField: field,
    });
  };

  const closeColorPicker = () => {
    setColorPickerState({
      open: false,
      anchorEl: null,
      activeField: null,
    });
  };

  return {
    colorPickerState,
    openColorPicker,
    closeColorPicker,
  };
};
